<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <ModalHeader
        title="Edit Cash Advance"
        icon="mdi-cash"
        @close="dialog = false"
      />
      <v-card-text class="pa-4">
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-cash"
          class="mt-n2"
          label="Amount"
          dense
          outlined
          v-model="item.amount"
        ></v-text-field>
        <v-text-field
          prepend-inner-icon="mdi-note-text"
          class="mt-n2"
          label="Reason"
          dense
          outlined
          v-model="item.reason"
        ></v-text-field>
        <!-- total paid -->
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-cash-multiple"
          class="mt-n2"
          label="Total Paid"
          dense
          outlined
          v-model="item.total_paid"
        ></v-text-field>
        <!-- balance -->
        <v-text-field
          type="number"
          prepend-inner-icon="mdi-cash-check"
          class="mt-n2"
          label="Balance"
          dense
          outlined
          v-model="item.balance"
        ></v-text-field>
        <!-- status dropdown -->
        <v-select
          :items="['unpaid', 'paid', 'deducted']"
          label="Status"
          dense
          outlined
          v-model="item.status"
          class="mt-n2"
        ></v-select>
        <!-- date issued -->
        <div class="d-flex">
          <p class="mr-2">Date Issued</p>
          <input type="date" v-model="item.date_issued" class="mt-n3" />
        </div>
        <!-- chart of account -->

        <v-select
          label="Chart of Account"
          dense
          outlined
          item-text="account_title"
          item-value="id"
          :items="chart_of_accounts"
          v-model="item.chart_of_account_id"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" @click="submit" :loading="loading">Edit</v-btn>
        <v-btn @click="$emit('close')"> Close</v-btn>
        <v-spacer></v-spacer>
        <p class="caption grey--text">itemProfileModal.vue</p>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["item"],
  data() {
    return {
      dialog: true,
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      edit_cash_advance: "cash_advance/edit_cash_advance",
    }),
    async submit() {
      //confirm
      let x = await this.$confirm({
        title: "Edit Cash Advance",
        message: "Are you sure you want to edit this cash advance?",
        color: "primary",
        icon: "mdi-pencil",
      });
      if (!x) return;
      this.edit_cash_advance(this.item);
      this.$alert({
        title: "Success",
        message: "Successfully edited a cash advance",
        color: "success",
        icon: "mdi-check-circle",
      });
      return;
    },
  },
  computed: {
    ...mapGetters({
      chart_of_accounts: "chart_of_account/chart_of_accounts",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
